<style scoped>
    .asset-print-container{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        font-size: 12px;
        z-index: 10000;
        color: #000;
        background: white;
    }
    .close-editor-btn{
        position: absolute;
        top: 20px;
        right: 20px;
    }
    @media print {
        .close-editor-btn{
            display: none;
        }
    }
    .print-content{
        display: inline-block;
        width: 40mm;
        height: 25mm;
        text-align: center;
        line-height: 14px;
        padding-top: 3mm;
        box-sizing: content-box;
    }
    .header-gap{
        margin-top: 3mm;
    }
</style>
<template>
    <div class="asset-print-container" v-show="is_show">
        <div class="close-editor-btn">
            <Button type="primary" @click="rePrint" icon="md-print">打印</Button>
            <Button type="warning" @click="close" icon="md-close">关闭</Button>
        </div>
        <div class="print-content" v-if="asset.uid">
            <div class="header-gap"></div>
            <qrcode :value="asset.uid" :size="68"></qrcode>
            <div>{{asset.uid}}</div>
            <div>{{asset.asset_name.name}}</div>
        </div>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    export default {
        data () {
            return {
                is_show: false,
                asset: {}
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            print(asset){
                this.is_show = true;
                Object.assign(this.asset, asset);
                setTimeout(()=>{
                    window.print();
                }, 100);
            },
            rePrint(){
                window.print();
            },
            close(){
                this.is_show = false;
            }
        }
    }
</script>
